// removed by extract-text-webpack-plugin
module.exports = {"contact":"src-index----index-module---contact---1d65g","imprint":"src-index----index-module---imprint---1bwZF","link":"src-index----index-module---link---2E7J_","logo":"src-index----index-module---logo---1LE1I","margin":"src-index----index-module---margin---3wq5l","portrait":"src-index----index-module---portrait---2lVHl","sidebar":"src-index----index-module---sidebar---14pwc"};


//////////////////
// WEBPACK FOOTER
// ./src/index/index.module.scss
// module id = 263
// module chunks = 11588923914802